import { ReactElement, useEffect, useState } from "react";
import { FC } from "react";

interface Props {
  className?: string | object;
  isChecked?: boolean;
  handleOnChange?: (e: any) => void;
  disabled?: boolean;
  name: string;
  id?: string;
  label?: string | ReactElement;
  value?: string;
}

const Checkbox: FC<Props> = ({
  className,
  isChecked = false,
  handleOnChange,
  disabled,
  name,
  id,
  label,
  value,
}) => {
  const [checked, setChecked] = useState(false);
  const [inputValue, setInputValue] = useState(0);

  const handleChange = () => {
    setChecked(!checked);
    setInputValue(inputValue ? 0 : 1);
    handleOnChange?.(!checked ? value : 0);
  };

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  return (
    <div className={`form__field form__field--checkbox ${className}`}>
      <input
        name={name}
        type="checkbox"
        id={id}
        onChange={handleChange}
        checked={checked}
        disabled={disabled}
        value={inputValue}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

Checkbox.defaultProps = {
  className: "",
  isChecked: false,
  disabled: false,
  name: "",
  id: "",
  label: "",
  value: "",
};
export default Checkbox;
